/* eslint-disable no-undef */
import '../App.css'
import React, { useEffect, useMemo, useState } from 'react';
import tg from '../assets/communication.png';
import web from '../assets/world-wide-web.png';
import x from '../assets/twitter.png';
import logo from '../assets/PUMPLOGO.png';
import { Web3 } from "web3";
import axios from 'axios';
import pp from '../assets/cartoon.png';
import yt from '../assets/youtube.png';
import pumpLogo from '../assets/logo.webp';
import tG from '../assets/tG.png';
import webG from '../assets/webG.png';
import xG from '../assets/xG.png';
import msImg from '../assets/ms.png';
import solImg from '../assets/sol2.png';

import { useLocation } from 'react-router-dom';

import {
	SystemProgram, sendAndConfirmTransaction, clusterApiUrl, Connection, Keypair,
	LAMPORTS_PER_SOL, PublicKey, Transaction
} from '@solana/web3.js';

import '../buffer-polyfill';


const renderer = ({ days, hours, minutes, seconds, completed }) => {
	/*	if (completed) {
			// Render a completed state
			return <Completionist />;
		} else {*/
	// Render a countdowns

	if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {

		window.location.reload(true);
		console.log("Mint Begins");
	}


	return <div class="counterBlock"><div class="days">{days}</div><div class="dots">:</div><div class="days">{hours}</div><div class="dots">:</div><div class="days">{minutes}</div><div class="dots">:</div><div class="sec">{seconds}</div></div>;
	/*	}*/
};

const ytL = () => {
	window.open("https://youtube.com/@pumpfound");
}

const tweet = () => {
	window.open("https://x.com/pumpfound");
}

const tgL = () => {
	window.open("https://t.me/pumpfound");
}

const homeLink = () => {
	window.open("http://www.pumpfound.com");
}

function Profile() {
	const clientID = "2f8f716d-b303-481b-80ef-febaf341524b";
	const web3 = new Web3("https://necessary-dry-breeze.bsc.quiknode.pro/d40c20a7d806cdc17501e901d0cf8147c30046de/");


	const [_totalSupply, settotalSupply] = useState(0);
	const [statusError, setstatusError] = useState("");
	const [statusLoading, setstatusLoading] = useState("");
	const [_owner, set_owner] = useState("");
	const [myNFTWallet, setmyNFTWallet] = useState(0);
	const [_public_mint_status, set_public_mint_status] = useState("");
	const [_navbarOpen, set_navbarOpen] = useState(0);
	const [_connected, setConnected] = useState(false);
	const [_registerDiv, set_registerDiv] = useState(0);
	const [_dashboardDiv, set_dashboardDiv] = useState(0);
	const [_name, set_name] = useState("");
	const [_success1, setSuccessMsg1] = useState("");
	const [_loading1, setLoadingMsg1] = useState("");
	const [_ErrorMsg1, setErrorMsg1] = useState("");
	const [success, setsuccess] = useState("");
	const [nfts, setNfts] = useState([]);
	const [selectedContractIndex, setSelectedContractIndex] = useState(0);
	const [userInfo, setUserInfo] = useState(null);
	const [userNFTs, setUserNFTs] = useState([]);
	const [nft1Collection, setUserInfoForNFT1] = useState([1, 2, 3]);
	const [nft2Collection, setUserInfoForNFT2] = useState([1, 2]);
	const [nft3Collection, setUserInfoForNFT3] = useState([1, 2, 3]);
	const [_viewUser, set_getUser] = useState("");
	const [_getRefferalCount, set_getRefferalCount] = useState(0);
	const [_getIdByAddress, set_getIdByAddress] = useState(0);

	const [_totalUsers, set_totalUsers] = useState("");
	const [_totalCommissions, setTotalCommissions] = useState(0);
	const [_totalCommissions2, setTotalCommissions2] = useState(0);
	const [_totalCommissions3, setTotalCommissions3] = useState(0);

	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [walletAddress, setWalletAddress] = useState(null);
	const [walletObject, setwalletObject] = useState(null);
	const [_signature, setSignature] = useState(false);
	const [_isPhantom, setIsPhantom] = useState(false);
	const [response, setResponse] = useState('');
	const [fetching, setFetching] = useState([]);

	const location = useLocation();
	const { state } = location;

	const {
		name,
		image,
		memeTicker,
		time,
		description,
		pump,
		moonshot,
		telegram,
		twitter,
		website,
		solScan

	} = state || {};

	async function closeNav() {
		set_navbarOpen(0);
	}

	async function navbarOpen() {
		set_navbarOpen(1);
	}

	async function fetchTokenDetails(tokenId, contractAddress) {
		// Call the getTokenDetails function from your contract ABI
		const tokenDetails = await getTokenDetails();
		// Do something with the token details, e.g., display them in UI
	}

	useEffect(() => {

		getDataFromServer();

	}, []);

	async function registerDivOpen() {
		set_registerDiv(1);
	}

	async function dashboardDivOpen() {
		set_dashboardDiv(1);
	}

	async function closediv() {
		set_registerDiv(0);
		set_dashboardDiv(0);
	}
	const fetchDetails = async () => {
		try {

			// Trigger the compilation first
			const mintResponse = await axios.post('https://pumpserver2.vercel.app/api/_fetchDetails',
				{
					image: _IMAGE,
					name: _Name,
					memeTicker: _MemeTicker,
					description: _Description,
					website: _Website,
					twitter: _Twitter,
					telegram: _Telegram,
					pump: _Pump,
					moonshot: _Moonshot,
					solScan: _SOLSCAN

				}

			);

		} catch (err) {
			console.log(err);
		}
	};

	const connectWallet = async () => {
		try {
			const { solana } = window;
			if (solana) {
				// Connect to the user's wallet and get their public key
				const response = await solana.connect();
				setWalletAddress(response.publicKey.toString());
				setwalletObject(response);

				// Sign a message using the user's wallet
				const message = Uint8Array.from([...new TextEncoder().encode('Welcome to PumpFound')]);
				const signedMessage = await solana.signMessage(message);

				// Check if the message property exists before converting it to an array
				let serializedMessage;
				if ('message' in signedMessage) {
					serializedMessage = Array.from(signedMessage.message);
				} else {
					serializedMessage = Array.from(Uint8Array.from(Buffer.from(signedMessage.signature)));
				}

				// Add the signature and serialized message to the response object
				response.signature = signedMessage.signature;
				response.serializedMessage = serializedMessage;

				console.log("Connected with public key:", response.publicKey.toString());
				console.log("Signature:", signedMessage.signature.toString());
				console.log("Serialized Message:", serializedMessage);

			}

		} catch (err) {
			console.log(err);
		}
	};

	const _disconnectWallet = async () => {
		try {
			//  await walletObject.disconnect();
			console.log("Disconnected from wallet");
			setWalletAddress(null);
			setwalletObject(null);
			window.location.reload(true);

		} catch {
			console.log(err);
		}
	};

	const shortenAddress = (address) => {
		return `${address.slice(0, 4)}...${address.slice(-3)}`;
	};

	const sendMoney = async () => {
		try {

			const connection = new Connection('https://api.devnet.solana.com', 'confirmed');

			const price = 0.0775 * LAMPORTS_PER_SOL;

			const transaction = new Transaction().add(
				SystemProgram.transfer({
					fromPubkey: walletObject.publicKey,
					toPubkey: new PublicKey('7SFwqFDjoQuNujWAYCbYiBguZ2oc5iTK7Fdi1DTSfeHs'),
					lamports: price,
				}),
			);


			//Source Account
			transaction.feePayer = walletObject.publicKey;
			transaction.recentBlockhash = (await connection.getRecentBlockhash()).blockhash;

			let signature;

			signature = await window.solana.signAndSendTransaction(transaction);

			console.log('Transaction sent:', signature);

			if (signature != null) {
				setResponse("Transaction Successful");
				setSignature(true);

			} else {
				setResponse("Please check again");
			}

		} catch (err) {
			console.log(err);
		}
	}


	const getDataFromServer = async () => {
		const response = await axios.get('https://pumpserver2.vercel.app/api/getallfriends');
		console.log("response :" + response.data);
		setFetching(response.data)
	};

	function convertUnixTimestampToDateString(timestamp) {
		const date = new Date(timestamp * 1000); // Convert to milliseconds
		const year = date.getFullYear();
		const month = date.getMonth() + 1;
		const days = date.getDate();
		const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const monthName = months[month - 1];
		const hours = date.getHours();
		const minutes = "0" + date.getMinutes();
		const formattedTime = hours + ':' + minutes.substr(-2);

		const now = new Date();
		const currentYear = now.getFullYear();

		let displayedYear = "";
		if (year >= currentYear) {
			displayedYear = String(year).slice(-2);
		} else {
			displayedYear = `20${currentYear % 100}`;
		}

		return `${days}-${monthName}-${displayedYear} ${formattedTime}`;
	}

	return (
		<div className="allWrap">
			<div className="light">

				<div className="headers">
					<div className="headers2">
						<div className="logo">
							<img className="logoPic" src={logo} onClick={() => window.location.href = '/'} />
						</div>
						<div className="right">
							<div className="icons">
								<div className="socialIcon">
									<img onClick={ytL} src={yt} />
								</div>
								<div className="socialIcon">
									<img onClick={tgL} src={tg} />
								</div>
								<div className="socialIcon">
									<img onClick={tweet} src={x} />
								</div>
								<div className="socialIcon">
									<img onClick={homeLink} src={web} />
								</div>
							</div>

							{!walletAddress ? (
								<button className="connectBtn" onClick={connectWallet}>Connect Wallet</button>
							) : (
								<button className="connectBtn" onClick={_disconnectWallet}>{shortenAddress(walletAddress)}</button>
							)}

						</div>
					</div>
				</div>

				<div className='profileSection'>
					<div className='mainImg'>
						<img src={image} />
					</div>

					<div className='nameProfile1'>{name} (Ticker {memeTicker})</div>
					<div className='nameProfile2'>Listed by {memeTicker}</div>
					<div className='nameProfile3'>{description}</div>

					<div className='profileSocialMain'>
						{website && (
							<a href={website} target="_blank" rel="noopener noreferrer">
								<div className='profileSocial1'>
									<img className='pumpLogoImg2' src={webG} alt="Website" />
									WEBSITE
								</div>
							</a>
						)}
						{telegram && (
							<a href={telegram} target="_blank" rel="noopener noreferrer">
								<div className='profileSocial2'>
									<img className='pumpLogoImg2' src={tG} alt="Telegram" />
									TELEGRAM
								</div>
							</a>
						)}
						{twitter && (
							<a href={twitter} target="_blank" rel="noopener noreferrer">
								<div className='profileSocial2'>
									<img className='pumpLogoImg2' src={xG} alt="X (Twitter)" />
									X (TWITTER)
								</div>
							</a>
						)}

						{solScan && (
							<a href={solScan} target="_blank" rel="noopener noreferrer">
								<div className='profileSocial2'>
									<img className='pumpLogoImg2' src={solImg} alt="SOLSCAN" />
									SOLSCAN
								</div>
							</a>
						)}
					</div>

					{pump && (
						<a href={pump} target="_blank" rel="noopener noreferrer">
							<div className='profileSocial3'>
								<img className='pumpLogoImg' src={pumpLogo} alt="pump.fun" />
								pump.fun
							</div>
						</a>
					)}
					{moonshot && (
						<a href={moonshot} target="_blank" rel="noopener noreferrer">
							<div className='profileSocial3'>
								<img className='pumpLogoImg' src={msImg} alt="moonshot" />
								pump.fun
							</div>
						</a>
					)}


					<div className='noteP'>This token is only listed on memeboard</div>

				</div>

			</div >
			<div className="footer">Copyright @ 2024 pumpfound.com limited</div>

		</div >
	);
};

export default Profile;